import {ElementRef} from '@angular/core'
import QrScanner from 'qr-scanner'
import {IQrScannerFactory} from './qr-scanner.provider'

export class QrFactory implements IQrScannerFactory {
  public getScanner(element: ElementRef, callback: (r: any) => void, options: any): QrScanner {
    return new QrScanner(element as unknown as HTMLVideoElement, callback, options)
  }

  public listCameras(requestLabels?: boolean): Promise<QrScanner.Camera[]> {
    return QrScanner.listCameras(requestLabels)
  }
}
